import React, { Component } from 'react';
import ForgetPassword from './forgetPassword';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as AccontAction from '../accountActions';

class ForgetPasswordForm extends Component {

	handleSubmit(values) {
		const { accountActions, history } = this.props;
		accountActions.onForgetPassword({ email: values.email, navigation: history });
	  }

	  onCreateAccount() {
		const { history } = this.props;
		history.push('/register');
	}
	render() {
		const { isLoading } = this.props;
		return (<ForgetPassword onSubmit={this.onSubmit}
			onCreateAccount={()=> this.onCreateAccount}
			isLoading={isLoading}
			handleSubmitBtn={values => this.handleSubmit(values)}
        />
		);
	}
}


const mapStateToProps = ({ userAccount }) => {
	const { isLoading } = userAccount;
	return {
	  isLoading,
	};
  };
  


const mapDispatchToProps = (dispatch) => {
	return {
		accountActions: bindActionCreators(AccontAction, dispatch),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgetPasswordForm));